// Layout of the app pages (/:lang/pt-mobile, /:lang/physics): screenshots,
// extra blocks and links. All texts are in src/translate/<lang>/translation.json
// under appPages.<id>.
export const appPages = {
  pt: {
    screens: {folder: 'pt-mobile', count: 6},
    faq: '/faq',
    privacy: '/privacy-policy',
    // Extra blocks below the main app: the Academy game mode and the web version
    sections: [
      {id: 'academy', screens: {folder: 'pt-academy', count: 6}},
      {id: 'web', screens: {folder: 'pt-web', count: 6, wide: true}, link: 'https://periodic-table.tech/'},
    ],
  },
  physics: {
    screens: {folder: 'physics', count: 8},
    privacy: {ru: '/physics/privacy-policy/ru', en: '/physics/privacy-policy/en'},
  },
};
